module.exports = __webpack_public_path__ + "media/acuity/custom-c452bf59.svg";